<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-17 15:40:03
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/cart/components/CantHeader/index.vue
-->
<template>
  <div class="title_con clearfix">
    <div class="font12 font_weight500 colo087 title_name left line_height_17">
      失效商品
    </div>
    <img
      src="@/assets/common/icon_right_go@2x.png"
      alt=""
      class="left right_go"
    />
    <div
      class="clear_all font10 font_weight400 colo087 line_height_18 right"
      @click="clearAllCant"
    >
      清空失效商品
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    clearAllCant() {
      this.$emit("clearAllCant");
    }
  }
};
</script>
<style lang="less" scoped>
.title_con {
  padding-bottom: 20px;
  background: #fff;
  .title_name {
    margin: 12px 0 0 42px;
  }
  .right_go {
    width: 24px;
    margin-top: 7px;
  }
  .clear_all {
    border-radius: 10px;
    border: 1px solid #000;
    padding: 0 11px;
    margin: 10px 12px 0 0;
    box-sizing: border-box;
  }
}
</style>
